// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"styles_checkboxContainer__3QV2f","checkbox":"styles_checkbox__fhfbM"};